import { ITaskDataRow, TaskDataRow } from "ui/Scripts/source/models/task/taskDataRow";

export interface ITaskDataRowEdit {
    canUpdateTask: boolean;
    item: ITaskDataRow;
}

export class TaskDataRowEdit implements ITaskDataRowEdit {
    canUpdateTask: boolean;
    item: TaskDataRow;

    constructor();
    constructor(obj: ITaskDataRowEdit);
    constructor(obj?: any) {
        this.canUpdateTask = obj && obj.canUpdateTask || false;
        this.item = null;
        if (obj && obj.item) {
            this.item = new TaskDataRow(obj.item);
        }
    }
}